import {Table} from 'antd';
import {toFSDateTime} from "../../util/timeutils";

export const TransactionLogTable = ({log, props}) => {
    const columns = [
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                return toFSDateTime(new Date(val));
            }
        },
        {
            title: 'Log',
            dataIndex: 'content',
            key: 'log'
        },
        {
            title: 'User',
            dataIndex: 'username',
            key: 'user'
        }
    ];

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <Table dataSource={log} columns={columns} pagination={tablePagination} />
}